<template>
    <div v-if="visible" class="bg-white card mb-2">
        <div class="card-body d-flex justify-content-evenly" style="gap: 1.25rem">
            <div>
                <div class="bg-info text-white d-inline-flex align-items-center justify-content-center toast-icon">
                    <i class="far fa-image"></i>
                </div>
            </div>

            <div>
                <span class="pull-right font-size-200 cursor-pointer toast-close" @click.stop.prevent="dismiss"></span>
                <p class="font-weight-bold font-size-125 mb-2">{{ translate('Did you know?') }}</p>
                <p class="mb-3">{{ mainText }}</p>
                <div class="d-flex align-items-center">
                    <button class="btn btn-info font-weight-bold" @click.stop.prevent="retryJobWithResizeImage">
                        <i class="far fa-chevron-right"></i> {{ translate('Try now') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import { TOAST_HIDE, TOASTS } from './toast-consts';
import TransFilter from '../mixins/TransFilter.vue';
import { ApiJob } from '../../../../../model/converter/api-job';
import { globalLogger } from '../../../../helper/global-logger';

export default {
    name: TOASTS.TOAST_RESULT_RESIZE_IMAGE,
    mixins: [TransFilter],
    props: {
        data: {
            type: ApiJob | null,
            default: null,
        },
    },
    beforeMount() {
        if (
            !testIsNonEmptyString(this.data?.id) ||
            !testIsNonEmptyString(this.data?.sat?.hierarchy?.path[0]?.id) ||
            !testIsNonEmptyString(this.data?.satLinks?.redo?.href?.link)
        ) {
            // try-now button cannot function if any of these are missing
            eventBus.emit(TOAST_HIDE, TOASTS.TOAST_RESULT_RESIZE_IMAGE);

            return;
        }

        this.job = this.data;
        this.visible = true;
        globalLogger.log('result - resize image toast - show');
    },
    computed: {
        mainText() {
            return this.translate(
                'For optimal results when enlarging images, we recommend utilizing our %optionName% tool.',
                {
                    '%optionName%': this.translate('AI image upscale'),
                }
            );
        },
    },
    methods: {
        dismiss() {
            globalLogger.log('result - resize image toast - dismiss');
            eventBus.emit(TOAST_HIDE, TOASTS.TOAST_RESULT_RESIZE_IMAGE);
        },
        retryJobWithResizeImage() {
            globalLogger.log('result - resize image toast - try');

            let insertPosition = this.job.satLinks.redo.href.link.indexOf('com/');
            let url = this.job.satLinks.redo.href.link.slice(0, insertPosition + 4);
            let j = this.job.sat.hierarchy.path[0].id;
            let route = 'upscale-image';

            window.location.href = url + route + '#j=' + j;
        },
    },
    data() {
        return {
            job: null,
            visible: false,
        };
    },
};
</script>

<style scoped lang="scss">
@use  '../../../../../../scss/abstracts/mixins';
@use  '../../../../../../scss/abstracts/variables' as *;
@use  '../../../../../../../../../../../assets/scss/abstracts/variables' as *;
@use  '../../../../../../scss/abstracts/functions';

.toast-icon {
    border-radius: 50%;
    width: 5rem;
    height: 5rem;
    font-size: 3rem;

    @media (max-width: $screen-xs-max) {
        width: 4rem;
        height: 4rem;
        font-size: 2.5rem;
    }
}

.toast-close:before,
.toast-close:after {
    position: absolute;
    left: 12px;
    content: ' ';
    height: 1.5rem;
    width: 2px;
    background-color: #333;
}

.toast-close:before {
    transform: rotate(45deg);
}

.toast-close:after {
    transform: rotate(-45deg);
}

.toast-close {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}
</style>
